export default __webpack_public_path__ + "static/media/news.a17c8fb5.jpg";